import discoverImg from '../assets/images/discover-img.jpg';
import headerImg2 from '../assets/images/header-image2.jpg'
import headerImg from '../assets/images/header-image.jpg';

const items = [
    {
        name: "PR Builders — Chennai construction",
        description: "Trusted builders in East Tambaram and Chennai: new homes, structural work, and turnkey construction with dependable timelines. Serving South Chennai and Tamil Nadu with expert craftsmanship.",
        img: headerImg2,
        bgPosition: "right",
        gradient: "to right, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.35)",
        direction: "row",
        buttonTitle: "Contact us",
        buttonLink: "/contact"
    },
    {
        name: "Constructed Stunning Projects",
        description: "Expertly crafted homes and projects across East Tambaram, Chennai—architectural excellence and quality construction for residential clients in Tambaram and beyond.",
        img: headerImg,
        bgPosition: "center",
        gradient: "to left, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.35)",
        direction: "row-reverse",
        buttonTitle: "View Here",
        buttonLink: "/projects"
    },
    {
        name: "Projects in East Tambaram & Chennai",
        description: "Explore premium sale projects from our Chennai team—smart buying, lasting value, and homes built to high construction standards in Tamil Nadu.",
        img: discoverImg,
        bgPosition: "center",
        gradient: "rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)",
        direction: "row-reverse",
        buttonTitle: "Sale projects",
        buttonLink: "/sale"
    },
];

export default items;